import { localize } from '../helpers';

export const templates = (translations: Record<string, string>, module: string) => {
    const data = {
        findNdsPayer: {
            nameServices: localize('find-nds-payer-service-search-vat-data', translations) + ':',
            link: '<div>[portal-host]/services/isnaportalsync/public/search-payer-data,</div> <div>[portal-host]/services/isnaportalsync/public/check-certificate-number-and-series-for-compliance</div>',
            method: 'GET',
            params:
                '<div>taxpayerCode: <ИИН/БИН></div>' +
                '<div>number: <Номер свидетельства></div>' +
                '<div>series: <Серия свидетельства></div>',
            resultExample: `{
    "iinBin": "string",
    "nameRu": "string",
    "nameEn": "string", 
    "nameKz": "string",
    "ndsRegistrationDate": "string",
    "ndsDeregistrationDate": "string",
    "ndsDeregistrationReason": "string" 
}`,
        },
        ServiceUnreliableTaxpayers: {
            nameServices: 'Поиск неблагонадежных НП:',
            link: '[portal-host]/services/isnaportal/public/taxpayer-data/search',
            method: 'POST',
            params: `-`,
            titleBody: 'Тело запроса: JSON-объект вида:',
            requestBody: `{
    "taxPayerCode": "String",
    "language": "rus",
    "rnn": "String",
    "taxPayerOrgName": "String",
    "directorIin": " String",
    "firstName": "String",
    "lastName": "String",
    "middleName": " String"
}`,
            resultExample: `[
    {
        "iin": "675344340213",
        "rnn": "2114343466660",
        "activity": null,
        "name": "ПРИМЕР РЕЗУЛЬТАТОВ СЕРВИСОВИЧ",
        "region": null,
        "taxOrgCode": null,
        "fullName": " ПРИМЕР РЕЗУЛЬТАТОВ СЕРВИСОВИЧ ",
        "directorFullName": "ПРИМЕР РЕЗУЛЬТАТОВ",
        "directorIin": "6704242300213",
        "directorRnn": null,
        "taxpayerDataList": [
            {
                "unreliableTaxpayerDataCategory": "ABSENT_ADDRESS_AGENT_DATA_LIST",
                "taxOrgCode": "2108",
                "dataReportDate": null,
                "actType": "ABSENT_ADDRESS",
                "actNumber": "132249",
                "actCreateDate": "2019-11-15T06:26:00"
            }
        ]
    }
]`,
        },
        FindTaxpayerService: [
            {
                nameServices: localize('api-search-tp', translations),
                link: '[portal-host]/services/isnaportalsync/public/taxpayer-data',
                method: 'GET',
                paramsTitle: 'Физическое лицо:',
                params: '<div>taxpayerCode: <ИИН></div>' + '<div>taxpayerType: FL</div>',
                resultExample: `{
  "taxpayerPortalSearchResponses": [
    {
      "responseMessageUid": "string",
      "messageResult": "string",
      "errorMessage": "string",
      "code": "string",
      "taxpayerType": "string",
      "fullName": {
        "lastName": "string",
        "firstName": "string",
        "middleName": "string"
      },
      "registrationType": {
        "code": "string",
        "ru": "string",
        "kk": "string",
        "en": "string",
        "qq": "string"
      },
      "beginDate": "string",
      "endDate": "string",
      "endReasonCode": "string",
      "additionalInfo": "string",
      "taxOrg": "string"
    }
  ]
}`,
            },
            {
                paramsTitle: 'Индивидуальный предприниматель:',
                params:
                    '<div>taxpayerCode: <ИИН/БИН></div>' +
                    '<div>taxpayerType: IP</div>' +
                    '<div>name: <Наименование ИП></div>',
                resultExample: `{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "IP",
            "fullName": "string or null",
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`,
            },
            {
                paramsTitle: 'Юридическое лицо:',
                params:
                    '<div>taxpayerCode: <БИН></div>' +
                    '<div>taxpayerType: UL & UL_NR</div>' +
                    '<div>name: <Наименование организации></div>',
                resultExample: `{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "UL",
            "fullName": "null",
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`,
            },
            {
                paramsTitle: 'Лицо, занимающееся частной практикой:',
                params:
                    '<div>taxpayerCode: <ИИН></div>' +
                    '<div>firstName: <Имя></div>' +
                    '<div>lastName: <Фамилия></div>' +
                    '<div>taxpayerType: LZCHP</div>',
                resultExample: `{
    "taxpayerPortalSearchResponses": [
        {
            "responseMessageUid": "string",
            "messageResult": "string",
            "errorMessage": "string",
            "code": "string",
            "taxpayerType": "LZCHP",
            "fullName": {
                "lastName": "string",
                "firstName": "string",
                "middleName": "string"
            },
            "registrationType": {
                "code": "string",
                "ru": "string",
                "kk": "string",
                "en": "string",
                "qq": "string"
            },
            "beginDate": "string",
            "endDate": "string",
            "endReasonCode": "string",
            "additionalInfo": "string",
            "taxOrg": "string"
        }
    ]
}`,
            },
        ],
        FindLiquidatedTaxpayer: {
            nameServices: 'Поиск НП на стадии ликвидации:',
            link: '[portal-host]/services/isnaportalsync/public/find-liquidated-taxpayer',
            method: 'GET',
            params: `{
    "taxpayerCode": "taxpayerCode",
    "name": "name",
    "fio": "fio",
    "date": "YYYY-MM-DD"
}`,
            resultExample: `[
    {
        "ru": "Товарищество с ограниченной ответственностью \"Атар\"",
        "kk": null,
        "en": null,
        "qq": null,
        "rnn": "30433333920",
        "iinBin": "923232323226",
        "firstName": null,
        "lastName": null,
        "middleName": null,
        "endDate": null,
        "beginDate": "2003-08-15",
        "type": "UL"
    }
]`,
        },
        FindRiskDegreeService: {
            nameServices: localize('api-risk-degree-category', translations),
            link: '[portal-host]/services/isnaportalsync/public/find-risk-degree',
            method: 'GET',
            params: localize('api-print-taxpayerCode', translations),
            resultExample: `{
    "taxpayerCode" : "iinBin",
    "name" : "NP name",
    "degree" : "degreeCode",
    "relevanceDate" : "yyyy-mm-ddT00:00:00.000+00:00",
    "beginDate" : "yyyy-mm-ddT00:00:00.000+00:00",
    "endDate" : "yyyy-mm-ddT00:00:00.000+00:00"
}`,
        },
        InfoAbsenceTaxDebt: {
            nameServices: 'Cведения об отсутствии (наличии) налоговой задолженности:',
            link: '[portal-host]/services/isnaportalsync/public/tax-debt-info',
            method: 'GET',
            params: `{
    "taxpayerCode": "ИИН/БИН налогоплательщика"
}`,
            resultExample: `{
    "iinBin": "94037870364",
    "totalArrear": 0,
    "totalTaxArrear": 0,
    "pensionContributionArrear": 0,
    "socialContributionArrear": 0,
    "socialHealthInsuranceArrear": 0,
    "taxOrgInfos": []
}`,
        },
        BankruptService: [
            {
                instructionTitle: `Инструкция по получению токена`,
                instruction: `Для того, чтобы получить токен необходимо выполнить следующие шаги:<br />
1. Зарегистрироваться в систему через ЭЦП ключ или авторизоваться (если имеется учетная запись)<br /> 
2. После успешной авторизации перейти в сервис и нажать на кнопку “Ссылка на API”<br /> 
3. Далее нажать на кнопку “Создать обращение” и заполнить форму для получения токена<br /> 
<br />
Для получения сведений по должнику, необходимо запустить нижеуказанный API. Потребуются следующие данные: токен (выше инструкция как получить ключ) и ИИН/БИН должника.`,
                nameServices: 'Получения сведений по должнику',
                link: '[portal-host]/services/isnaportal/open-api/bankrupt-service/event-data',
                method: 'POST',
                headers: `Key - X-Portal-Token
Value - d0b1e1d5-6d8a-493c-8240-435c1e743b04 //токен`,
                requestBody: `{
    "iin_bin": "string", 
}`,
                resultExampleInstruction: `Тип события с датами и прочими данными по запрашиваемому должнику.`,
                resultExample: `[
    {
        "iin_bin": "911021336991",
        "event_type": 14,
        "event_date": "2023-01-28",
        "publication_date": null,
        "court_name": "Акмолинский областной суд"
    },
    {
        "iin_bin": "911021336991",
        "event_type": 4,
        "event_date": "2023-01-28"
    },
    {
        "iin_bin": "911021336991",
        "event_type": 16,
        "event_date": "2023-01-28",
        "publication_date": null
    }
]`,
            },
        ],
    };
    const result = data[module];
    return Array.isArray(result) ? { services: result } : result;
};
